import { dashboardColors } from 'common/enums/ColorEnum';
const charcoalGreyCode = dashboardColors.charcoalGrey.code;

export const mapPoiVisibilityStyles = [
    {
        featureType: 'poi',
        elementType: 'All',
        stylers: [
            {
                visibility: 'on'
            }
        ]
    },
    {
        featureType: 'transit.line',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    }
];

const darkMapPoiStyles = [
    ...mapPoiVisibilityStyles,
    {
        featureType: 'poi',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: charcoalGreyCode
            },
            {
                lightness: -10
            }
        ]
    },
    {
        featureType: 'poi',
        elementType: 'geometry.stroke',
        stylers: [
            {
                color: charcoalGreyCode
            },
            {
                lightness: -20
            }
        ]
    },
    {
        featureType: 'poi',
        elementType: 'labels.icon',
        stylers: [
            {
                hue: charcoalGreyCode
            },
            {
                saturation: -70
            },
            {
                lightness: -10
            },
            {
                gamma: 0.75
            }
        ]
    },
    {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'poi',
        elementType: 'labels.text.stroke',
        stylers: [
            {
                color: charcoalGreyCode
            },
            {
                lightness: 40
            }
        ]
    },
    {
        featureType: 'poi.park',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: charcoalGreyCode
            },
            {
                lightness: 5
            }
        ]
    }
];

const darkMapVisibilityStyles = [
    {
        featureType: 'All',
        elementType: 'All',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'administrative',
        elementType: 'All',
        stylers: [
            {
                visibility: 'on'
            }
        ]
    },
    {
        featureType: 'landscape',
        elementType: 'All',
        stylers: [
            {
                visibility: 'on'
            }
        ]
    },
    {
        featureType: 'road',
        elementType: 'All',
        stylers: [
            {
                visibility: 'on'
            }
        ]
    },
    {
        featureType: 'transit',
        elementType: 'All',
        stylers: [
            {
                visibility: 'simplified'
            }
        ]
    },
    {
        featureType: 'water',
        elementType: 'All',
        stylers: [
            {
                visibility: 'on'
            }
        ]
    }
];

const darkMapTextStyles = [
    {
        featureType: 'road',
        elementType: 'labels.text.fill',
        stylers: [
            {
                visibility: 'simplified'
            }
        ]
    },
    {
        featureType: 'administrative',
        elementType: 'labels.text',
        stylers: [
            {
                color: charcoalGreyCode
            }
        ]
    },
    {
        featureType: 'administrative',
        elementType: 'labels.text.fill',
        stylers: [
            {
                lightness: 20
            }
        ]
    },
    {
        featureType: 'administrative.country',
        elementType: 'labels.text.stroke',
        stylers: [
            {
                color: charcoalGreyCode
            },
            {
                lightness: 80
            }
        ]
    }
];

export const darkMapStyles = [
    ...darkMapVisibilityStyles,
    ...darkMapTextStyles,
    {
        featureType: 'administrative',
        elementType: 'geometry',
        stylers: [
            {
                color: charcoalGreyCode
            }
        ]
    },
    {
        featureType: 'administrative.country',
        elementType: 'geometry.stroke',
        stylers: [
            {
                color: charcoalGreyCode
            },
            {
                lightness: -5
            }
        ]
    },
    {
        featureType: 'administrative.province',
        elementType: 'geometry.stroke',
        stylers: [
            {
                color: charcoalGreyCode
            },
            {
                lightness: 15
            }
        ]
    },
    {
        featureType: 'landscape',
        elementType: 'label',
        stylers: [
            {
                visibility: 'simplified'
            },
            {
                lightness: 40
            }
        ]
    },
    {
        featureType: 'landscape.man_made',
        elementType: 'geometry',
        stylers: [
            {
                color: charcoalGreyCode
            }
        ]
    },
    {
        featureType: 'landscape.natural',
        elementType: 'geometry',
        stylers: [
            {
                color: charcoalGreyCode
            },
            {
                lightness: 5
            }
        ]
    },
    {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [
            {
                color: charcoalGreyCode
            },
            {
                lightness: -10
            }
        ]
    },
    {
        featureType: 'road',
        elementType: 'labels.icon',
        stylers: [
            {
                visibility: 'simplified'
            }
        ]
    },
    {
        featureType: 'road.arterial',
        elementType: 'geometry.stroke',
        stylers: [
            {
                color: charcoalGreyCode
            },
            {
                lightness: -20
            }
        ]
    },
    {
        featureType: 'road.highway',
        elementType: 'labels.icon',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'road.local',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: charcoalGreyCode
            },
            {
                lightness: 5
            }
        ]
    },
    {
        featureType: 'road.local',
        elementType: 'geometry.stroke',
        stylers: [
            {
                color: charcoalGreyCode
            },
            {
                lightness: -15
            }
        ]
    },
    {
        featureType: 'transit',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: charcoalGreyCode
            },
            {
                lightness: -10
            }
        ]
    },
    {
        featureType: 'transit',
        elementType: 'labels',
        stylers: [
            {
                saturation: -60
            },
            {
                lightness: -10
            }
        ]
    },
    {
        featureType: 'water',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: charcoalGreyCode
            },
            {
                lightness: 10
            }
        ]
    }
];

export const liteMapStyles = [
    {
        featureType: 'poi',
        elementType: 'All',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'administrative.neighborhood',
        elementType: 'labels.text',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'road',
        elementType: 'labels',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'water',
        elementType: 'labels.text',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'transit',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    }
];

export const darkMapWithPlacesStyles = [...darkMapStyles, ...darkMapPoiStyles];
